import type { GraphQLSubscription } from 'aws-amplify/api';
import { transcriptionClient } from '../../core/Amplify/transcriptionClient';

export type TranscriptUpdate = {
  callSid: string;
  streamSid?: string | null;
  seq?: number | null;
  atTicks?: number | null;
  sortTicks?: string | null;
  isPartial?: boolean | null;
  text?: string | null;
  languageCode?: string | null;
  role?: string | null;
};

const onTranscriptUpdate = /* GraphQL */ `
  subscription OnTranscriptUpdate($callSid: ID!) {
    onTranscriptUpdate(callSid: $callSid) {
      callSid
      streamSid
      seq
      atTicks
      sortTicks
      isPartial
      text
      languageCode
      role
    }
  }
`;

type OnTranscriptUpdateSubscription = {
  onTranscriptUpdate: TranscriptUpdate;
};

export function subscribeTranscriptUpdates(
  callSid: string,
  next: (evt: { data?: OnTranscriptUpdateSubscription }) => void,
  error?: (err: unknown) => void
) {
  console.info('[Transcription] subscribe start', { callSid });
  const sub = transcriptionClient
    .graphql<GraphQLSubscription<OnTranscriptUpdateSubscription>>({
      query: onTranscriptUpdate,
      variables: { callSid },
    })
    .subscribe({
      next: (evt) => {
        console.debug('[Transcription] event', evt);
        next(evt);
      },
      error: (err) => {
        console.error('[Transcription] subscription error', err);
        error?.(err);
      },
      complete: () => {
        console.warn('[Transcription] subscription complete');
      },
    });

  return () => {
    console.info('[Transcription] unsubscribe');
    sub.unsubscribe();
  };
}
